// config
export const SET_GLOBAL = "SET_GLOBAL";

// window
export const SET_MENU_TOGGLE = "SET_MENU_TOGGLE";

export const SET_FULL_SCREEN_TOGGLE = "SET_FULL_SCREEN_TOGGLE";

export const SET_FULL_VW = "SET_FULL_VW";

export const SET_BREAD_CRUMB_STATUS = "SET_BREAD_CRUMB_STATUS";

export const SET_MENU_TABS = "SET_MENU_TABS";

export const SET_ACTION_TAB = "SET_ACTION_TAB";

// user
export const SET_USER_INFO = "SET_USER_INFO";

export const SET_RESOURCE = "SET_RESOURCE";

export const SET_NOT_READ_SYSTEM_MESSAGE_COUNT =
  "SET_NOT_READ_SYSTEM_MESSAGE_COUNT";

export const SET_SELECTEDDATA = "SET_SELECTEDDATA";

export const DELETE_SELECTEDDATA = "DELETE_SELECTEDDATA";

export const SET_ASIDEMENULIST = "SET_ASIDEMENULIST";

// socket
export const SOCKET_CONNECT = "SOCKET_CONNECT";

export const SOCKET_SUBSCRIBE = "SOCKET_SUBSCRIBE";

export const SOCKET_EMIT = "SOCKET_EMIT";

export const SOCKET_GATEWAY = "SOCKETS_GATEWAY";

export const SOCKET_MESSAGE = "SOCKETS_MESSAGE";

export const SOCKET_SENDER = "SOCKETS_SENDER";

export const CLEAR_SOCKET_MESSAGE = "CLEAR_SOCKET_MESSAGE";

export const SOCKET_RESPONSE = "SOCKETS_RESPONSE";

export const CLEAR_SOCKET_SENDER = "CLEAR_SOCKET_SENDER";

export const CLEAR_SOCKET_GATEWAY = "CLEAR_SOCKET_GATEWAY";

export const CLEAR_SOCKET_RESPONSE = "CLEAR_SOCKET_RESPONSE";

export const ACT_CUR_PAGE = "ACT_CUR_PAGE";

export const ACTIVITY_CUR_PAGE = "ACTIVITY_CUR_PAGE";

export const SET_BRABNS = "SET_BRABNS";
